module.exports = __webpack_public_path__ + "img/googleplay.68e5501c.svg";